import React from "react";
import ReactDOM from "react-dom";
import {
  Section,
  Image,
  Headline,
  Paragraph,
  Box,
  Heading,
  Label,
} from "grommet";

import gameplay from "./gameplay.gif";
import missileCommand from "./missile-command.png";

const TrajectileCommand = (props) => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Trajectile Command
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box direction="column" basis="2/3" margin="small" textAlign="left">
        <Image src={gameplay} size="large" />
        <Paragraph>
          Trajectile Command is a virtual reality game that loads in the browser
          and uses WebGL to display on a vr headset such as the htc vive,
          occulus rift and windows mixed reality hmds. It has been optimised to
          run on Oculus Quest as well. It's an arcade style game where you
          defend your cities from waves of enemy bombers and missiles by
          instructing your own missile launchers where to fire.
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          It's inspired from an old arcade classic called Missile Command.
          Except updated in a way that would only be possible with a virtual
          reality headset and 6dof tracked controls.
        </Paragraph>
        <Paragraph size="small">
          <Image src={missileCommand} size="small" />
          <br />
          <Label size="small">Missile Command</Label>
        </Paragraph>

        <Paragraph>
          Trajectile Command is built with A-Frame and ThreeJS. It takes
          advantage of modern javascript development tools such as webpack. I
          was impressed that this workflow gave a similar experience to working
          in Unity.
        </Paragraph>
        <Paragraph size="small">
          <a href="/trajectilecommand">Play it here</a> -- You'll need a VR
          enabled browser and a headset.
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default TrajectileCommand;



// WEBPACK FOOTER //
// ./src/components/projects/trajectile-command/trajectile-command.js